import { isNotOpenCatalogedModal } from "@/atoms/item/is-not- open-cataloged-modal";
import { isNotOpenDisplayedModal } from "@/atoms/item/is-not-open-displayed-modal";
import { isNotOpenForSaleModal } from "@/atoms/item/is-not-open-for-sale-modal";
import { isOpenCatalogedModal } from "@/atoms/item/is-open-cataloged-modal";
import { isOpenDiscountModal } from "@/atoms/item/is-open-discount-modal";
import { isOpenDisplayedModal } from "@/atoms/item/is-open-displayed-modal";
import { isOpenForSaleModal } from "@/atoms/item/is-open-for-sale-modal";
import { isOpenPriceModal } from "@/atoms/item/is-open-price-modal";
import { isBatchDiscountModal } from "@/atoms/item/is-batch-discount-modal";
import { ItemDetailDto } from "@/types/dto/item-detail-dto";
import { useRecoilValue } from "recoil";
import { DiscountModal } from "../modal/DiscountModal";
import { IsCatalogedModal } from "../modal/IsCatalogedModal";
import { IsDisplayedModal } from "../modal/IsDisplayedModal";
import { IsForSaleModal } from "../modal/IsForSaleModal";
import { IsNotCatalogedModal } from "../modal/IsNotCatalogedModal";
import { IsNotDisplayedModal } from "../modal/IsNotDisplayedModal";
import { IsNotForSaleModal } from "../modal/IsNotForSaleModal";
import { PriceModal } from "../modal/PriceModal";
import { BatchDiscountModal } from "../modal/BatchDiscountModal";

export const SingleProductCreatePageModalPanel = () => {
  const isCatalogedModalOpen = useRecoilValue<ItemDetailDto | undefined>(
    isOpenCatalogedModal
  );
  const isForSaleModalOpen = useRecoilValue<ItemDetailDto | undefined>(
    isOpenForSaleModal
  );
  const isDisplayedModalOpen = useRecoilValue<ItemDetailDto | undefined>(
    isOpenDisplayedModal
  );
  const isNotCatalogedModalOpen = useRecoilValue<ItemDetailDto | undefined>(
    isNotOpenCatalogedModal
  );
  const isNotForSaleModalOpen = useRecoilValue<ItemDetailDto | undefined>(
    isNotOpenForSaleModal
  );
  const isNotDisplayedModalOpen = useRecoilValue<ItemDetailDto | undefined>(
    isNotOpenDisplayedModal
  );
  const isPriceModalOpen = useRecoilValue<boolean>(isOpenPriceModal);
  const isDiscountModalOpen = useRecoilValue<boolean>(isOpenDiscountModal);
  const isBatchDiscountModalOpen = useRecoilValue(isBatchDiscountModal);

  return (
    <>
      {isNotCatalogedModalOpen && <IsNotCatalogedModal />}
      {isCatalogedModalOpen && <IsCatalogedModal />}
      {isNotDisplayedModalOpen && <IsNotDisplayedModal />}
      {isDisplayedModalOpen && <IsDisplayedModal />}
      {isNotForSaleModalOpen && <IsNotForSaleModal />}
      {isForSaleModalOpen && <IsForSaleModal />}
      {isPriceModalOpen && <PriceModal />}
      {isDiscountModalOpen && <DiscountModal />}
      {isBatchDiscountModalOpen.isOpen && <BatchDiscountModal />}
    </>
  );
};
